<template>
  <div class="planList-wrap">
    <el-dialog
      title="关联计划"
      :visible.sync="showDialog"
      width="866px"
      :close-on-click-modal="false"
      top="8vh"
    >
      <div class="dialog-body">
        <div class="table-header">
          <div class="table-text">定向包名称：<span>男性</span></div>
          <el-input
            placeholder="请输入名称"
            suffix-icon="el-icon-search"
            v-model="searchStr"
            style="width: 160px; margin-left: auto"
          >
          </el-input>
        </div>
        <el-table :data="[]" style="width: 100%" height="500px">
          <el-table-column prop="date" label="广告账户名称"> </el-table-column>
          <el-table-column prop="date" label="广告账户ID"> </el-table-column>
          <el-table-column prop="date" label="广告组名称"> </el-table-column>
          <el-table-column prop="date" label="广告组ID"> </el-table-column>
          <el-table-column prop="date" label="广告计划名称"> </el-table-column>
          <el-table-column prop="date" label="广告计划ID"> </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <div></div>
        <el-button type="primary" @click="showDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false,
      searchStr: "",
    };
  },
  methods: {
    showModal() {
      this.showDialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-body {
  .table-header {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
  }
}
</style>